const icons = {
  cancelIcon:
    '/devices/static/media/CancelIcon.4a680ec674d45aedd6e89ae20cd65a01.svg',
  tickMark:
    '/devices/static/media/TickMark.078c285f36f8a2cbb2df8118c93faa01.svg',
  sortByIcon:
    '/devices/static/media/SortByIcon.fde1968002097ee49df2d0c0534d6687.svg',
  filterIcon:
    '/devices/static/media/FilterIcon.61112dd382a9f4adbc73154166efe16f.svg',
  // Featured Icons
  featuredIconBlack:
    '/devices/static/media/FeaturedIconBlack.38606793f09161552cac581010f2fe6e.svg',
  featuredIconBlue:
    '/devices/static/media/FeaturedIconBlue.efb807f34fd902bdbea11db534062809.svg',
  // Price Icons
  priceIconBlack:
    '/devices/static/media/PriceIconBlack.cf948f0fcc8c0b634aae5b6aa07641e5.svg',
  priceIconBlue:
    '/devices/static/media/PriceIconBlue.5d11513e9ceced33849b788780a5c97e.svg',
  // Newer Option Icons
  newerIconBlack:
    '/devices/static/media/NewerIconBlack.38e38915aadc7ea5a78e0ff188a5d97b.svg',
  newerIconBlue:
    '/devices/static/media/NewerIconBlue.82a7a2ffa6809861759242f340210f84.svg',
}

export default icons
